import React from "react";
import axios from "axios";
import Hls from "hls.js";
import { getQueryVariable } from "Helpers/QueryString"

import CheckBandwidth from "./CheckBandwidth"
import { languages, languageKeys } from "../Helpers/languages";
import { BASE_PATH } from "../constants/awsBaseUrl";

const checkCaptions = async (video, translations=[]) => {
  let toReturn = []
  try {
    let res = await axios.head(`${BASE_PATH}/captions/${video}.vtt`)
    toReturn.push({
      key: "0",
      src: `${BASE_PATH}/captions/${video}.vtt`,
      srcLang: "en",
      label: "English",
      kind: "captions"
    })
  } catch (err) {
    console.error("Error heading caption file:")
    console.error(err)
  }
  for(let lang of translations) {
    try {
      let res = await axios.head(`${BASE_PATH}/captions-translated/${video}/${video}-${lang}.vtt`)
      toReturn.push({
        key: lang,
        label: `${languages.find((lan) => lan.key === lang)?.language}`,
        kind: "captions",
        srcLang: lang,
        src: `${BASE_PATH}/captions-translated/${video}/${video}-${lang}.vtt`
      })
    } catch (err) {
      console.error("Error heading translated caption file:")
      console.error(err)
    }
  }
  return toReturn
}

class Video extends React.Component {

  constructor(props) {
    super(props)
    this.videoplayer = React.createRef();
    // We don't want react to update when this changes, so that is why it is not in state
    this.bufferSize = 0
    // Ditto for this
    this.maxLoadedFrag = -1
  }

  state = {
    file: this.props.video,
    url: "",
    updating: false,
    price: 0,
    shouldPlay: this.props.embed ? true : true,
    videoMP4URL: '',
    videoPaidFor: false,
    user: this.props.pub_user ? this.props.pub_user._id : "", // this is the viewer in the DB
    customThumb:false,
    captions: []
  };

  componentDidMount() {
    if (this.props?.downloadsDisabled) {
      this.disableContextMenu();
    };

    // check if the video is a live stream then fetch the live stream from aws
    if (this.props.type === "live") {
      this.setState({ file: this.props.video });
      axios.get(`${BASE_PATH}/outputs/${encodeURIComponent(this.state.file)}/Default/Thumbnails/out_003.png?refresh=${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}`)
        .then(res=>{if(res.status==200){this.setState({customThumb:true})}})
      this.startLive()
    } else {
      this.setState({ file: this.props.video });  //set the file state with the video Id
      this.getVideo();
    }
    // this.loadCaptionsData();
    this.mounted = true;
    this.start();
  }

  startLive = () => {
    axios.post(`${this.props.url}/upload/getLive`, {live: this.props.video})
      .then(res => {
        if (this.mounted && res.data.response.success) {
          let {live} = res.data.response.payload
          live = live.trim();
          this.setState({url: live });
          this.createhls(live);
        }
      });
  }

  // default attempt is to get video in HLS format; that is why type is initialized to HLS
  getVideo = (type="HLS") => {
    
    axios.post(this.props.url + "/upload/get", {
        file: this.props.video,
        type,
        user: this.props.pub_user ? this.props.pub_user._id : ""
      }).then(res => {
        if (this.mounted && res.data.response) {
          if (res.data.response.payload.data === "/") {
            /* 
              fetch details if a pay-to-view video has been bought.
              along with the url to the mp4 version of that video.
              Only run if a user has been logged in
            */
            if (this.props.viewerId) {
       
              //If no url is returned in the response retrieve mp4 version from the stripe api
              axios.post('https://do2v45e3qi.execute-api.us-west-2.amazonaws.com/production/get-video-from-aws',
              {
                videoId: this.state.file, 
                viewerId: this.props.viewerId
              })
              .then(res =>{
          
                this.setState({
                  videoMP4URL: res.data.videoMP4.split('?')[0] , 
                  videoPaidFor: res.data.videoHasBeenPaidFor
                });
              })
            }
            this.setState({
              shouldPlay: false,
              price: res.data.response.payload.price,
            });
          } else {
            this.setState({
              url: res.data.response.payload.data.split('?')[0] ,
              price: 0,
              shouldPlay: this.props.embed ? false : true,
            });

            if (
              res.data.response.payload.data
                .split("/")
                [res.data.response.payload.data.split("/").length - 1].split(
                  "?"
                )[0]
                .split(".")[1] === "mp4"
            ) {
              if(this.props.type !== "live") {
                checkCaptions(this.state.file || this.props.video, this.props.translations)
                  .then((res) => {this.setState({captions: res})})
                  .catch((err) => {console.error("Error checking for caption files:");console.error(err)})
              }
              this.createmp4(res.data.response.payload.data);
            } else {
              if(this.props.type !== "live") {
                checkCaptions(this.state.file || this.props.video, this.props.translations)
                  .then((caps) => {
                    this.setState({captions: caps})
                    this.createhls(res.data.response.payload.data);
                  })
                  .catch((err) => {
                    console.error("Error checking for caption files:");console.error(err)
                    this.createhls(res.data.response.payload.data);
                  })
              } else {
                this.createhls(res.data.response.payload.data);
              }
            }
          }
        }
      }).catch((err) => {
        console.error(err);
        if(type === "HLS") {
          console.warn("HLS Failed. Trying MP4...")
          this.getVideo("MP4")
        }
      })
  };

  start = () => {
    if (this.mounted) {
      setTimeout(() => {
        this.start();
      }, 1000);
    }
    try {
      if (this.state.shouldPlay)
        this.props.update(document.getElementById("video").currentTime);

    } catch (e) {
      this.mounted = false;
    }
  };

  // The names of the translations can sometimes be keys. That does not
  // look good to the user therefore.
  assignKeyCaptions = (languageKey='es') => {
    try {
      if (!(languageKey in languageKeys)) {
        throw new Error('Language Key DNE in languages list!');
      };
      return languages[languageKey];
    } catch (err) {
      console.error('assignKeyCaptions - ', err);
      return languageKey;
    };
  }

  // used for getting rid of the dropdown menu for right clicking
  disableContextMenu = () => {
    this.videoplayer.current.addEventListener('contextmenu', this.preventDefault);
  }

  // remove listener when user cursor moves awat from video
  removeContextMenuListener = () => {
    this.videoplayer.current.removeEventListener('contextmenu', this.preventDefault);
  }

  // this is a helper to make sure default doesnt prevent functionality
  preventDefault = (event) => {
    event.preventDefault();
  };

  componentWillUnmount() {
    if (this.props?.downloadsDisabled) {
      this.removeContextMenuListener();
    };
    // this.removeCaptionsDataListener();
    this.setViews(true)
    this.mounted = false;
  }

  componentDidUpdate() {
    if (!this.state.updating && this.props.shouldUpdate) {
      this.setState({ updating: true });
      document.getElementById("video").currentTime = this.props.scrubTo;
      this.props.clearUpdate();
      this.setState({ updating: false });
    }
    if (
      this.state.file !== this.props.video ||
      (this.props.pub_user && this.state.user !== this.props.pub_user._id)
    ) {
      this.setState({
        file: this.props.video,
        user: this.props.pub_user._id,
      });
      if (this.props.type === "live") {
        if(this.hls) {
          this.hls.destroy()
        }
        this.startLive()
      } else {
        this.getVideo();
      }
    }
    if (this.props.file.metadata) {
      this.insAndOuts(this.props.file.metadata);
    }
  }


  createmp4 = (url) => {
    let video = this.videoplayer.current;
    video.src = url;
    document.getElementById("video").currentTime = getQueryVariable(
      "start"
    );
    let playPromise = video.play();
    // Handling rejected promise from video.play to prevent the DOMException that comes from an unhandled play promise
    playPromise.catch((err) => {
      if(err.name === "AbortError") {
        // This is expected if playback was aborted because the video player unmounted in between play being called and resolving,
        // so no need to log in that case.
        if(this.mounted) {
          console.error(`Video Playback aborted: ${err.message}`)
        }
      } else {
        console.error(`Error playing video: ${err}`)
      }
    })
  };

  createhls = (url) => {
    if (Hls.isSupported()) {
      let video = this.videoplayer.current;
      this.bufferSize = 0;
      let hls = new Hls({ 
        autoStartLoad: true, 
        enableCEA708Captions: !(this.state.captions && this.state.captions.length),
        manifestLoadingTimeOut: 20000,
        manifestLoadingMaxRetry: 3,
        manifestLoadingRetryDelay: 1000
      });
      hls.attachMedia(video);
      hls.on(Hls.Events.MEDIA_ATTACHED, () => {
        hls.loadSource(url);
      });
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        if (this.props.embed) {
        } else {
          document.getElementById("video").currentTime = getQueryVariable(
            "start"
          );
          let playPromise = video.play();
          // Handling rejected promise from video.play to prevent the DOMException that comes from an unhandled play promise
          playPromise.catch((err) => {
            if(err.name === "AbortError") {
              // This is expected if playback was aborted because the video player unmounted in between play being called and resolving,
              // so no need to log in that case.
              if(this.mounted) {
                console.error(`HLS Playback aborted: ${err.message}`)
              }
            } else {
              console.error(`Error playing hls: ${err}`)
            }
          })
        }
      });
      hls.on(Hls.Events.BUFFER_APPENDING, (e, data) => {
        if(data && data.data) {
          this.bufferSize += data.data.byteLength
        }
      })
      // If the m3u8 goes back to fragment 0, that means that the ip output was probably restarted
      // When this happens, we need to restart Hls.js in order to continue playback correctly.
      hls.on(Hls.Events.FRAG_LOADING, (event, data) => {
        if(this.props.type === "live") {
          let {frag} = data
          if(frag.sn > this.maxLoadedFrag) {
            this.maxLoadedFrag = frag.sn
          } else if(frag.sn === 0) {
            // RESET
            this.maxLoadedFrag = -1
            hls.destroy();
            this.startLive();
          }
        }
      })
      hls.on(Hls.Events.ERROR, (event, data) => {
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.MEDIA_ERROR:
              console.log('fatal media error encountered, try to recover');
              hls.recoverMediaError();
              break;
            case Hls.ErrorTypes.NETWORK_ERROR:
              console.error('fatal network error encountered', data);
              // All retries and media options have been exhausted.
              // Immediately trying to restart loading could cause loop loading.
              // Consider modifying loading policies to best fit your asset and network
              // conditions (manifestLoadPolicy, playlistLoadPolicy, fragLoadPolicy).
              break;
            default:
              // cannot recover
              hls.destroy();
              // recreate if live
              if(this.props.type === "live") {
                this.startLive()
              }
              break;
          }
        }
      });
      this.hls = hls;
    }

  };



  getCaptions = (newCaptions=null) => {
    if (this.props.type === "live") {
      return null;
    } else if(this.state.captions && this.state.captions.length) {
      if (newCaptions !== null) {
        this.setState({ ...this.state, captions: newCaptions });
      };
      return this.state.captions.map((props) => (
        <track {...props}/>
      ))
    }
    /*
    else if(this.props.translations?.length>0){
      return (
        <>
        <track
          label="English"
          kind="captions"
          srcLang="en"
          src={
            "https://dlttx48mxf9m3.cloudfront.net/captions/" +
            this.props.video +
            ".vtt"
          }
        />
        {this.props.translations && languages && this.props.translations.map(keycode=>(
          <track
            label={languages.filter(lan=>lan.key==keycode)[0]?.language}
            kind="captions"
            srcLang={keycode}
            src={
              `https://dlttx48mxf9m3.cloudfront.net/captions-translated/${this.props.video}/${this.props.video}-${keycode}.vtt`        
            }
          />
        ))}
       
        </>
      )
    }
    else {
      
      return (
        <track
          label="English"
          kind="captions"
          srcLang="en"
          src={
            "https://dlttx48mxf9m3.cloudfront.net/captions/" +
            this.props.video +
            ".vtt"
          }
        />
      );
    }*/
   
  };

  setViews = (force=false) => {
    let viewData = {}
    /* Handled by the bandwidth events, so no longer needed on frontend
    if(this.bufferSize) {
      viewData.byteLength = this.bufferSize
    }
    */
    if(this.videoplayer.current) {
      if(this.videoplayer.current.videoWidth && this.videoplayer.current.videoHeight) {
        viewData.vWidth = this.videoplayer.current.videoWidth
        viewData.vHeight = this.videoplayer.current.videoHeight
      }
      if(this.videoplayer.current.played) {
        let ranges = this.videoplayer.current.played
        let arr = []
        for(let i = 0; i < ranges.length; i++) {
          arr.push({
            start: ranges.start(i),
            end: ranges.end(i)
          })
        }
        if(arr.length) {
          viewData.played = arr
        }
      }
    }
    this.props.setViews(force, viewData, this.props.type)
  }

  insAndOuts = (metadata) => {
    let ins = parseInt(metadata.in ? metadata.in : metadata.In, 10);
    let outs = parseInt(metadata.out ? metadata.out : metadata.Out, 10);
    var time = document.getElementById('video');

    if (time.currentTime < ins) {
      time.currentTime = ins;
    } else if (time.currentTime > outs) {
      time.currentTime = outs;
      if(this.mounted && this.videoplayer.current) {
        this.videoplayer.current.pause()
      }
    }
  }

  filterValidCaptions = () => {
    try {
      const videoElement = this.videoplayer?.current;
      if (videoElement && videoElement?.textTracks && videoElement?.textTracks?.length > 0) {
        const newValues = Array.from(videoElement.textTracks).map((track) => {
          if (track?.label && track?.label?.length <= 2) {
            track.label = this.assignKeyCaptions(track?.language);
          };
          return track;
        });
        console.log('new styuff', newValues);
        this.getCaptions(newValues);
        return newValues;
      };
      return videoElement?.textTracks;
    } catch (err) {
      console.error(err);
    };
  }

  render() {
    let customThumbnailUrl=`url('${BASE_PATH}/outputs/${encodeURIComponent(this.state.file)}/Default/Thumbnails/out_003.png?refresh=${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}')`
    let og = `url('${BASE_PATH}/outputs/${this.state.file}/Default/Thumbnails/out_003.png?refresh=${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}')`
 
    return (
      <div style={{ position: "relative" }}>
        {!this.state.videoPaidFor && <div className="video-thumbnail"
          style={{
            backgroundImage:this.state.customThumb?customThumbnailUrl:og,
            display: this.state.shouldPlay ? "none" : "flex",
          }}
        >
          
          
          <div>
            <i className={ "fas " + (this.state.price > 0 ? "fa-dollar-sign" : "fa-play-circle")}
              onClick={() => {
                this.props.setItemBeingBought('payToView');
                if (this.state.price > 0) {
                  // prompt user to make an account 
                  if (this.props.pub_user._id === "") {
                    this.props.register();
                  } else {
                    this.setState({ checkout: true });
                  }
                } else {
                  let video = this.videoplayer.current;
                  video.play();
                  this.setState({ shouldPlay: true });
                }
              }}
              ></i> 
          </div>
        </div>}

        <video
          width="100%"
          controls
          ref={this.videoplayer}
          controlsList='nodownload'
          id="video"
          crossOrigin="anonymous"
          poster={`${BASE_PATH}/outputs/${encodeURIComponent(this.state.file)}/Default/Thumbnails/out_003.png?refresh=${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}`||`${BASE_PATH}/outputs/${
            encodeURIComponent(this.state.file)
          }/Default/Thumbnails/out_003.png`}
          // src={(this.state.url ? this.state.url : this.state.videoMP4URL)}
          onTimeUpdate={() => this.setViews()}
          onPause={() => this.setViews(true)}
          onPlay={() => {
            this.setViews(true)
          }}
          style={{ borderRadius: '4px' }}
          onLoad={() => this.filterValidCaptions()}
          playsInline
          // onLoadedMetadata={() => this.filterValidCaptions()}
        >
          <source src={this.state.url} type="application/x-mpegURL" />
          {this.getCaptions()}
        </video>
      </div>
    );
  } 
}
export default CheckBandwidth(Video);
